<aur-page>
  <header>
    <!-- TODO: translate -->
    <h1>{{ 'ARC_COMPOSITE_SYSTEM' | translate }}</h1>
  </header>
  <div class="p-grid">
    <div class="p-col-4">
      <aur-card>
        <header>
          <h2>Module Configurations</h2>
        </header>
        <div>
          <p-accordion [multiple]="true">
            <p-accordionTab>
              <p-header>
                Credit
              </p-header>
              <!-- <button aur-button importance="secondary" [disabled]="true">More Settings...</button> -->
              <button aur-button importance="tertiary" id="more-settings-link-credit" [routerLink]="'/system/credit-admin'"  [disabled]="!(enableCreditSettingsButton$ | async)">More Settings...</button>
            </p-accordionTab>
            <p-accordionTab>
              <p-header>
                Invoicing
              </p-header>
              <button id="more-settings-button-invoicing" aur-button importance="tertiary"
                [disabled]="true"
                (click)="refreshDemoData($event)">More Settings...</button>
            </p-accordionTab>
            <p-accordionTab>
              <p-header>
                Payments
              </p-header>
              <button aur-button importance="tertiary" id="more-settings-link-payments" [routerLink]="'/system/payments-settings'">More Settings...</button>
            </p-accordionTab>
            <p-accordionTab>
              <p-header>
                {{ 'ARC_COMPOSITE_APPLICATION_TAB_BPN' | translate }}
              </p-header>
              <button aur-button importance="tertiary" id="more-settings-link-bpn" [routerLink]="'/system/digital-lockbox-settings'"
                [disabled]="(enableBpnSettings$ | async)===false">More Settings...</button>
            </p-accordionTab>
            <p-accordionTab>
              <p-header>
                CashApp
              </p-header>
              <button id="more-settings-button-cashapp" aur-button importance="tertiary" [disabled]="true">More
                Settings...</button>
            </p-accordionTab>
            <p-accordionTab  *arcSharedPermission="'arc-permission-section-icontroller-collections-permission-configuration:read'">
              <p-header>
                Collections
              </p-header>
              <button aur-button importance="tertiary" id="more-settings-link-ic-collections" [routerLink]="'/system/iccollections-admin'">More Settings...</button>
            </p-accordionTab>
            <p-accordionTab>
              <p-header>
                Disputes
              </p-header>
              <button aur-button importance="tertiary" id="more-settings-link-dispute-configuration" [routerLink]="'/system/dispute-configuration'">More Settings...</button>
            </p-accordionTab>
          </p-accordion>
        </div>
      </aur-card>
    </div>
    <div class="p-col-8">
        <aur-card>
          <header>
            <h2>{{ 'ARC_CONFIGURATION_SETTINGS_HEADER_LABEL' | translate }}</h2>
            <aur-popup-menu id="btnSettingsMore" [items]="editProfileMenuItems$ | async"></aur-popup-menu>
          </header>
          <div class="p-col-12">
            <dl id="secSSOConfiguration" *arcSharedPermission="
                permissionDefinition.SSOConfiguration + ':read'
              ">
              <dt>SSO Setting</dt>
              <dd>
                <arc-configuration-sso-entry (errorClick)="openSystemDrawer($event, 'btnSSOConfiguration')"
                  (canceled)="canceled($event)">
                </arc-configuration-sso-entry>
              </dd>
            </dl>
            <dl id="secMerchantAccounts"
              *arcSharedPermission="'arc-payments-permission-cardmerchantaccountmanagement:read'">
              <dd style="height:60px">
                <pay-account-summary></pay-account-summary>
              </dd>
            </dl>
          </div>
        </aur-card>
        <aur-card>
          <header>
            <h2></h2>
          </header>
        </aur-card>
    </div>
  </div>
  <app-system-drawer #drawer [settingSections]="editProfileMenuItems$ | async" [activeSection]="selectedMenu">
  </app-system-drawer>
</aur-page>